import { gql, useQuery } from "@apollo/client";

interface PushProviderEventBreakdownResponse {
  pushProviderEventBreakdown: {
    errors: Array<{ path: string; message: string }> | null;
    message: string | null;
    windowHours: number;
    providers: Array<{
      provider: string;
      received: number;
      clicked: number;
      read: number;
      failed: number;
      total: number;
    }>;
  };
}

interface PushProviderEventBreakdownVariables {
  windowHours?: number;
}

interface PushProviderEventMetricsResponse {
  pushProviderEventMetrics: {
    errors: Array<{ path: string; message: string }> | null;
    message: string | null;
    processed: number;
    updated: number;
    duplicate: number;
    invalid: number;
    missingAlert: number;
    received: number;
    clicked: number;
    read: number;
    failed: number;
  };
}

export const pushProviderEventBreakdownQuery = gql`
  query PushProviderEventBreakdownQuery($windowHours: Int) {
    pushProviderEventBreakdown(windowHours: $windowHours) {
      errors {
        path
        message
      }
      message
      windowHours
      providers {
        provider
        received
        clicked
        read
        failed
        total
      }
    }
  }
`;

export const pushProviderEventMetricsQuery = gql`
  query PushProviderEventMetricsQuery {
    pushProviderEventMetrics {
      errors {
        path
        message
      }
      message
      processed
      updated
      duplicate
      invalid
      missingAlert
      received
      clicked
      read
      failed
    }
  }
`;

export function usePushProviderEventBreakdown(windowHours?: number) {
  const { data, loading, error, refetch } = useQuery<
    PushProviderEventBreakdownResponse,
    PushProviderEventBreakdownVariables
  >(pushProviderEventBreakdownQuery, {
    variables: {
      windowHours,
    },
    notifyOnNetworkStatusChange: true,
  });

  return {
    breakdown: data?.pushProviderEventBreakdown,
    loading,
    error,
    refetch,
  };
}

export function usePushProviderEventMetrics() {
  const { data, loading, error, refetch } = useQuery<PushProviderEventMetricsResponse>(
    pushProviderEventMetricsQuery,
    {
      notifyOnNetworkStatusChange: true,
    },
  );

  return {
    metrics: data?.pushProviderEventMetrics,
    loading,
    error,
    refetch,
  };
}
